import { render } from "./homeUserCenter.vue?vue&type=template&id=cd915668&scoped=true"
import script from "./homeUserCenter.vue?vue&type=script&lang=js"
export * from "./homeUserCenter.vue?vue&type=script&lang=js"

import "./homeUserCenter.vue?vue&type=style&index=0&id=cd915668&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd915668"]])

export default __exports__